import { Translate } from "next-translate";
import * as zod from "zod";
import { QuestionAnswer } from "~/models/questionAnswer";
import { Task } from "~/models/task";
import { User } from "~/models/user";

export const FIRESTORE_COLLECTION_NAME_TALK_ROOM = "talkRooms";
export const FIRESTORE_COLLECTION_NAME_TALK_ROOM_COMMENT = "comments";

export enum TalkRoomCommentTypeEnum {
  normal = "normal",
  positiveFeedback = "positiveFeedback",
}

export interface TalkRoom {
  createdUnixTime: number;
  id: string;
  questionAnswerId: QuestionAnswer["id"];
  taskId: Task["id"];
  updatedUnixTime: number;
}

export interface TalkRoomComment {
  createdUnixTime: number;
  id: string;
  createdUserId: User["id"];
  message: string;
  type: TalkRoomCommentTypeEnum;
  updatedUnixTime: number;
}

export const TALK_ROOM_COMMENT_SCHEMA = (t: Translate) =>
  zod.object({
    message: zod.string().nonempty({
      message: t("form:validation.empty-input", {
        name: t("talkRoom:label-message"),
      }),
    }),
  });
